import { render, staticRenderFns } from "./ScenarioView.vue?vue&type=template&id=20bc9a78&scoped=true&"
import script from "./ScenarioView.vue?vue&type=script&lang=js&"
export * from "./ScenarioView.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioView.vue?vue&type=style&index=0&id=20bc9a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc9a78",
  null
  
)

export default component.exports